import React from 'react';
import { useTheme } from 'styled-components';

const CustomizeFormViewIcon = () => {
  const theme = useTheme();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_286_233)">
        <path
          d="M21.81 3.94C20.27 7.78 16.41 13 13.18 15.59L11.21 17.17C10.96 17.35 10.71 17.51 10.43 17.62C10.43 17.44 10.42 17.24 10.39 17.05C10.28 16.21 9.90002 15.43 9.23002 14.76C8.55002 14.08 7.72002 13.68 6.87002 13.57C6.67002 13.56 6.47002 13.54 6.27002 13.56C6.38002 13.25 6.55002 12.96 6.76002 12.72L8.32002 10.75C10.9 7.52 16.14 3.64 19.97 2.11C20.56 1.89 21.13 2.05 21.49 2.42C21.87 2.79 22.05 3.36 21.81 3.94Z"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.43 17.62C10.43 18.72 10.01 19.77 9.22003 20.57C8.61003 21.18 7.78003 21.6 6.79003 21.73L4.33003 22C2.99003 22.15 1.84003 21.01 2.00003 19.65L2.27003 17.19C2.51003 15 4.34003 13.6 6.28003 13.56C6.48003 13.55 6.69003 13.56 6.88003 13.57C7.73003 13.68 8.56003 14.07 9.24003 14.76C9.91003 15.43 10.29 16.21 10.4 17.05C10.41 17.24 10.43 17.43 10.43 17.62Z"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.24 14.47C14.24 11.86 12.12 9.73999 9.51001 9.73999"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.12 12.73L20.86 13.46C22.35 14.95 22.35 16.42 20.86 17.91L17.9 20.87C16.43 22.34 14.94 22.34 13.47 20.87"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M3.11001 10.51C1.64001 9.02 1.64001 7.55 3.11001 6.06L6.07001 3.1C7.54001 1.63 9.03001 1.63 10.5 3.1L11.24 3.84"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M11.25 3.84998L7.54999 7.54998"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M20.12 12.73L17.16 15.68"
          stroke={theme?.dark ? '#F3E6F4' : '#4A154B'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_286_233">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CustomizeFormViewIcon;
